export function isEmbedded() {
    return window.self !== window.top;
}

export function hasFullBackground() {
    return !!document.getElementsByClassName('has-full-background')?.length;
}

export function isAdminApp() {
    return document.getElementsByClassName('admin-app').length > 0;
}
